import React from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { Container } from "reactstrap"
import AuditTicketList from "./AuditTicketList"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

const AuditTicketView = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Audit Trails | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Audit Trails" breadcrumbItem="Audit Trails" />
          <AuditTicketList />
        </Container>
      </div>
    </React.Fragment>
  )
}

AuditTicketView.propTypes = {
  match: PropTypes.object,
}

export default withRouter(AuditTicketView)
